let ga;

if (process.env.NODE_ENV !== "production") {
	ga = (...args) => console.log(`%cga(${args.map(it => JSON.stringify(it)).join(", ")})`, "color: #aaa");
} else {
	/* eslint-disable */
	(function (i, s, o, g, r, a, m) {
	i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
		(i[r].q = i[r].q || []).push(arguments)
	}, i[r].l = 1 * new Date(); a = s.createElement(o),
		m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
	})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
	/* eslint-enable */

	ga = (...args) => window.ga(...args);
	ga("create", window.DCM_SETTINGS.GA_TRACKING_ID, "auto");
}

export default ga;


// WEBPACK FOOTER //
// ./src/assets/scripts/domain/ga.js